/*
Modification provided by Searchanise support team, with any questions, contact us at feedback@searchanise.io

INSTRUCTIONS

Settings section contains the promoteCollections variable, it includes the search queries that collections should be promoted for.
The content of the promoteCollections section starts and end with curly braces {}.

The search query contais the list of the collections it promotes. 
Search query should be put between quote marks. Lower-case should be used. The list of the collection is contained between square braces [].
Closing square brace should be followed by a comma.

Individual collection blocks are contained inside curly braces {}. 
Closing curly brace should be followed by a comma.
Collection information should contain the title and the link of the collection.

*/

// SETTINGS START


let queriesForSize = ["size 12","size","size 5","10 wide","size 5 sandals","size 6","8w","women size 12","11w","women’s size 12","size 43","trophy 2 size 9","womens size 12","11 wide","8 wide","size 10","size 11 wide","size 12 sandals","size 12 women","7.5 wide","9w","size 11","10w","2 sandals","6.5 wide","7 wide","how to size","size 12 womens","size 4","size 41","size 5.5","size 7.5","size 9","Size chart","size up","size up or down","womens size 9.5","10 w","10.5 wide","10.5 wide on sale","42 wide","7w","8W","Half sizes","sandal size","sandals in size 12","sandals size 12","Size","size 10 clearance","size 10 wide width","size 11 shoes","size 11w","size 12 womens sandals","size 36","size 36 sandals","size 38 sandals","size 39","size 40 in size","Size 5","size 5 shoes","size 5 women","size 5 women sneakers","size 5 womens","size 5.5 womens","size 6 wide","size 8 wide","size 8.5","size 9.5","size up or","taos size 5.5","white sandals size 8","women size","womens sandals size","1 wide","10.5 sandles","10.5 wide shoe","10.5 wide women sandle","10w women's sandals","11 wide sale","11 wide sandles","11w canvas","12 size sandals","12 women","12 womens","13 wide","13 wide sandals","15% off","2 for 100 sale","2 strap sandals","20 off","3 strap sandles","38 caramel","39 size","4 sandals","43 womens","5.5 size","5.5 wide shoes","6 wide","6 wide women’s sandal","6.5 wide sneakers","6w canvas sneakers","7 w","7 W women’s sandals","7 wide sandals","7.5w","8 slide sandals","8 wide sandal","8 wide sandals","8.5 size","8.5 wide","8.5w","9 sandals","9.5 women’s","9n","all women’s size 5 to 6","any size 5 shoes","arch support sandals size 7","black sandals size 7","black size 8","blue sandals in size 6","blue sneakers size 10","brown size","canvas sneakers size 12","Clearance size 40","do you have size 5","european size","european size 38","gift 2 white size 8","green size 9","Half size","half size","Half size?","is size in","luckie size 41","mens shoes size 14","on size 38 sandals","pewter size 9 womens gift 2 sandals","plim soul lux women's sneaker size 11","sale sandals size 7","sale size 10 and 11","sale size 10 sandles","sale size 11","sale size 8","sale womens size 9","sandal in size 5","sandal size 12","sandals black size 9","sandals in size","sandals sale size","sandals sale size 8","sandals size","sandals size 12 womens","sandals size 40","sandals size 42","sandals size 5","sandals size 8","sandals size 8w","sandals size 9","sandles tan size 42","shoe size","shoe size 7.5","shoe size 8.5","Shoe sizes","shoe sizes","size 10 sale","size 10 sale shoes","size 10 wide","size 10 women's wedges","size 10.5","size 10.5 us","size 11 w","size 11 wide sandals","size 11 women","size 11 womens","size 11w casual","Size 12","size 12 black","size 12 black sandals","size 12 black womens sandals","size 12 casual shoes","size 12 sandle","size 12 sandles","size 12 shoes","size 12 wide width womens shoes","size 12 wine","Size 12 women’s","size 12 women’s","Size 12 womens","size 12 womens sandal","size 13","size 42 sandals","size 43 women","size 43 women’s shoe","size 5 med","size 5 sandal","size 5 women’s","size 6 sandal","size 6 sandals","size 6 wide sandals","size 6 wide width sandals","size 7","size 7 as europe","size 7 black sandal","size 7 in european","size 7 silver","size 7 wide black sandal","size 8 wide width women's sneakers","size 8.5 the","size 8w","size 9 sandal","size 9 sandles","size 9 wide","size canvas sneakers","size for","size for 7","size for sandals","Size guide","size is 38 us","size is 39","size is 42","size or","Size quest","size sandal","size shoes","size us 6.5","size w","Size5.2","sneaker size 6","sneakers size 12","sneakers size 9.5","the perfect sandal black size 6","the shoe size 8","the show size 11","the show size 9","Trulie stone size 41","up one size","wear size 9","What about half sizes","white leather size 11 wide","white sandal size 7","white sandal size 8","white sandals size 11","white sandals size 6","white size 8 sandles","wide size 10","women sandles size 10","women’s sandals sandain size 12","women’s sandals size 11","women’s sandals size 8","women’s size 10 wide","women's size 11 sandals","women’s size 11w sandals","women's size 12","Women’s size 12","Women’s size 12 sandles","women’s size 13","women’s size 42","women’s size 44","women's star canvas sneaker size 12 white","women’s wide width in size 12","womens sandals size 10 1 w","womens sandals size 6","womens sandles size 12","womens size 11","womens size 12 sandals","womens size 7 sandles","womens size 8","womens size 8 wide","womens sneakers size 9"];

// SETTIGS END. DON'T EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        let isCollectionsLoaded = false;
        let isPagesLoaded = false;
        let collectionsAdditionalInfo = [];
        let pagesAdditionalInfo = [];
        let queryAdded = [];

        $(document).on('Searchanise.DataRequestBefore', function(event, type, params) {
            if (type == 'results' && params && params.q) {
                if (promoteCollections[params.q.toLowerCase()]) {
                    if(!promoteCollections[params.q]) {
                        return;
                    }
                    for (let collection of promoteCollections[params.q].reverse()) {
                        setTimeout(function() {
                            Searchanise.GetWidgets().processRequest(Searchanise.GetWidgets().paths.request_url, {
                                q: collection.title,
                                apiKey: Searchanise.ApiKey,
                                items: false,
                                pages: false,
                                suggestions: false,
                                categories: true
                            }, function(data) {
                                let isCollectionAlreadyAdded = false;
                                for (let collection of collectionsAdditionalInfo) {
                                    if (collection['category_id'] == data.categories[0]['category_id']) {
                                        isCollectionAlreadyAdded = true;
                                    }
                                }
                                if (!isCollectionAlreadyAdded) {
                                     if(!data.categories){
                                        return;
                                    }
                                    collectionsAdditionalInfo.push(data.categories[0]);
                                }
                            });
                        }, 0);
                        let stopInterval = 0;
                        let waitForCollections = setInterval(function() {
                            if (collectionsAdditionalInfo.length == promoteCollections[params.q].length || stopInterval > 20) {
                                isCollectionsLoaded = true;
                                clearInterval(waitForCollections);
                            }
                            stopInterval++;
                        }, 100);
                    }
                } else if (queriesForSize.includes(params.q) || promotePages[params.q.toLowerCase()]) {
                    let currentPagesObj = queriesForSize.includes(params.q) ? promotePages['what-size-am-i'] : promotePages[params.q];
                    for (let page of currentPagesObj.reverse()) {
                        setTimeout(function() {
                            Searchanise.GetWidgets().processRequest(Searchanise.GetWidgets().paths.request_url, {
                                q: page.title,
                                apiKey: Searchanise.ApiKey,
                                items: false,
                                pages: true,
                                suggestions: false,
                                categories: false
                            }, function(data) {
                                let isPageAlreadyAdded = false;
                                for (let page of pagesAdditionalInfo) {
                                    if (page['page_id'] == data.pages[0]['page_id']) {
                                        isPageAlreadyAdded = true;
                                    }
                                }
                                if (!isPageAlreadyAdded) {
                                    pagesAdditionalInfo.push(data.pages[0]);
                                }
                            });
                        }, 0);
                        let stopInterval = 0;
                        let waitForPages = setInterval(function() {
                            if (pagesAdditionalInfo.length == currentPagesObj.length || stopInterval > 20) {
                                isPagesLoaded = true;
                                clearInterval(waitForPages);
                            }
                            stopInterval++;
                        }, 100);
                    }
                }
            }
        });

        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (promoteCollections[params.q] && !queryAdded.includes(params.q)) {
                for (let collection of promoteCollections[params.q].reverse()) {
                    data.categories.unshift(collection);
                }
                let collectionTitles = [];
                let toBeSpliced = [];
                data.categories.forEach(function(item, index) {
                    if (!collectionTitles.includes(item.title.toLowerCase())) {
                        collectionTitles.push(item.title.toLowerCase());
                    } else {
                        toBeSpliced.push(index);
                    }
                });
                for (let i = 0; i < toBeSpliced.length; i++) {
                    data.categories.splice(toBeSpliced[i] - i, 1);
                }
                queryAdded.push(params.q);
            } else if (
                (queriesForSize.includes(params.q) || promotePages[params.q])
                && !queryAdded.includes(params.q)
            ) {
                let currentPagesObj = queriesForSize.includes(params.q) ? promotePages['what-size-am-i'] : promotePages[params.q];
                for (let page of currentPagesObj.reverse()) {
                    data.pages.unshift(page);
                }
                let pageTitles = [];
                let toBeSpliced = [];
                data.pages.forEach(function(item, index) {
                    if (!pageTitles.includes(item.title.toLowerCase())) {
                        pageTitles.push(item.title.toLowerCase());
                    } else {
                        toBeSpliced.push(index);
                    }
                });
                for (let i = 0; i < toBeSpliced.length; i++) {
                    data.pages.splice(toBeSpliced[i] - i, 1);
                }
                queryAdded.push(params.q);
            }
        });

        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            if ($('.snize-main-panel-controls-categories.active').length) {
                
                let prevQ = Searchanise.GetWidgets().searchResults.getPrevData().params.q;
                if(!promoteCollections[prevQ]) {
                    return;
                }
                let stopInterval = 0;
                let waitForCollections = setInterval(function() {
                    if (collectionsAdditionalInfo.length == promoteCollections[prevQ].length) {
                        clearInterval(waitForCollections);
                        for (let collectionItem of $('.snize-category')) {
                            for (let collectionData of collectionsAdditionalInfo) {
                                if (collectionData.title == $('.snize-view-link', collectionItem).attr('aria-label') && $(collectionItem).prop('id') == 'snize-category-undefined') {
                                    $(collectionItem).prop('id', `snize-category-${collectionData.category_id}`);
                                    if ($('.snize-description', collectionItem).length) {
                                        $('.snize-description', collectionItem).remove();
                                    }
                                    let displayStatus = collectionData.image_link ? "block" : "none";

                                    if (!$('.snize-thumbnail', collectionItem).length) {
                                        $('.snize-item', collectionItem).prepend(`<span class="snize-thumbnail" style="display:${displayStatus};"><img src="${collectionData.image_link}" class="snize-item-image " alt="${collectionData.title}" border="0" loading="lazy"></span>`);
                                    }
                                }
                            }
                        }
                    }
                    if (stopInterval > 20) {
                        clearInterval(waitForCollections);
                    }
                    stopInterval++;
                }, 100);
            }
        });
    })(window.Searchanise.$);
});